import { render, staticRenderFns } from "./PatientList2.vue?vue&type=template&id=e9c3080c"
import script from "./PatientList2.vue?vue&type=script&lang=js"
export * from "./PatientList2.vue?vue&type=script&lang=js"
import style0 from "./PatientList2.vue?vue&type=style&index=0&id=e9c3080c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports